import { render, staticRenderFns } from "./ReviewedUserInformation.vue?vue&type=template&id=b101d0f4&"
import script from "./ReviewedUserInformation.vue?vue&type=script&lang=js&"
export * from "./ReviewedUserInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports